module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAQhJREFUWEftl6FuAlEQRc91VTWYugaDKQJVVcInkPRLMHxBDb+CralFVFTxARiSJjWEhNSgSKZBbNKkyya8CwUxKzd77puc9zKzT1z5oyuvjyzQ3aE0mAZdAy7/5wxGxP7dGGi74QX8CniRtKvYugIHwKwg/FTIUNJrU4G3wBTonmrFI3KWwLOk9cECjwj7l0+zD7qa02AadA24fO0ZjIgboOWGF/AbSdvfXN0kuQc+gLuCBVzkG3iUtGiaJD1gDhf72+5Lem+cJBHxBDy4Ogr4T0lvjVtcEHpWJBu1qzcNpkHXgMsfujSNgI4bXsB/AZO8NBWYq5C8NBny6tFs1K7SNJgGXQMu/wOPejcpMFw44gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ico_nav.png
// module id = RVoB
// module chunks = 0